"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateSonosInvoiceSaleforceSchema = void 0;
exports.CreateSonosInvoiceSaleforceSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        invoice: {
            properties: {
                currencyIsoCode: {
                    type: 'string',
                },
                invoiceDate: {
                    type: 'string',
                },
                externalId: {
                    type: 'string',
                },
                status: {
                    type: 'string',
                },
                totalAmount: {
                    type: 'number',
                },
                taxAmount: {
                    type: 'number',
                },
                description: {
                    type: 'string',
                },
            },
            required: ['externalId', 'status', 'invoiceDate'],
            type: 'object',
        },
        subscription: {
            properties: {
                externalId: {
                    type: 'string',
                },
            },
            required: ['externalId'],
            type: 'object',
        },
    },
    required: ['invoice', 'subscription'],
    type: 'object',
};
//# sourceMappingURL=data:application/json;base64,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